module.exports = __webpack_public_path__ + "static/img/regCode-2.3e1826b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/regCode-2.png
// module id = 31rC
// module chunks = 1